import gql from 'graphql-tag';

export default gql`
  mutation adminEditOrganizationProfile($input: AdminEditOrganizationProfileInput!) {
    adminEditOrganizationProfile(input: $input) {
      id
    }
  }
`;
